<button class="{{ 'btn btn-' + type }}">
  <div class="d-flex">
    <i class="material-icons">{{ icon }}</i
    >{{ text | translate }}
  </div>
</button>
